/**
 * 下载管理 - 类型定义
 *
 * 数据源：从 3 个模块的 export_list 接口聚合
 *   - mingyang_project.export_list
 *   - mingyang_check.export_list
 *   - mingyang_knowledge.export_list
 */

export type DownloadModule = 'project' | 'check_record' | 'knowledge'

export type DownloadStatus = 0 | 1 | 2 // 0-等待中(后端生成中) / 1-已完成 / 2-失败

export interface DownloadRecord {
  /** 任务 id（唯一） */
  id: string | number
  /** 任务名称（如 "检查项记录导出-20260512-100530"） */
  name: string
  /** 导出模块 */
  module: DownloadModule
  /** 任务状态 */
  status: DownloadStatus
  /** 导出条数（处理中/失败为 null） */
  row_count: number | null
  /** 已完成时的 OSS 签名链接 */
  download_url: string
  /** 失败原因（status=2 时有值） */
  error_msg?: string
  /** 操作人 */
  operator: string
  /** 开始时间 */
  start_time: string
  /** 结束时间（处理中为空） */
  end_time: string
}

export const MODULE_MAP: Record<DownloadModule, string> = {
  check_record: '检查项记录',
  knowledge: '知识库',
  project: '检查项配置'
}

export const MODULE_COLORS: Record<
  DownloadModule,
  { color: string; bg: string }
> = {
  check_record: { color: '#1E40AF', bg: '#E9F2FF' },
  knowledge: { color: '#10A66B', bg: '#E7F8EF' },
  project: { color: '#D46B08', bg: '#FFF4EC' }
}

export const STATUS_LABEL: Record<DownloadStatus, string> = {
  0: '等待中',
  1: '已完成',
  2: '失败'
}
